import { buildPaginationPayload, normalizePaginationPayload } from '@/composables/shared/usePagination';
import { extractPayload } from '@/utils/dataNormalization';

export const fetchCustomersListPayload = async (customersService, params = {}, fallbackPagination = {}) => {
  const response = await customersService.index(params);
  const payload = extractPayload(response);
  const rows = Array.isArray(payload?.data) ? payload.data : [];
  const hasServerPagination = payload?.pagination && typeof payload.pagination === 'object';

  return {
    data: rows,
    pagination: hasServerPagination
      ? normalizePaginationPayload(payload?.pagination, fallbackPagination)
      : buildPaginationPayload({
        currentPage: 1,
        pageSize: Number(fallbackPagination?.per_page || 20),
        totalItems: rows.length,
      }),
  };
};
